module.exports = __webpack_public_path__ + "img/benefits-teachers-3.26bc227f.svg";